// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__7Qk4a","wrap_tablet":"styles_wrap_tablet__nVlPO","chapters_button_wrap":"styles_chapters_button_wrap__B8GRy","nextPrevButtons":"styles_nextPrevButtons__S-Y16"};